import { createApi } from "@reduxjs/toolkit/query/react";
import { sessionApi } from "../Constant";
import { encryptedBaseQueryWithReauth } from "../utilities/encryptedBaseQuery";

export const SessionApi = createApi({
    reducerPath: "SessionApi",
    baseQuery: encryptedBaseQueryWithReauth(process.env.REACT_APP_LOCAL_URL),
    endpoints: (builder) => ({

        getSessionList: builder.query({
            query: (endpoint) => `${endpoint}`,
            providesTags: ["getAnnouncementList"],
        }),

        createSession: builder.mutation({
            query: ({ data }) => ({
                url: `${sessionApi.endPoint}/create`,
                method: "POST",
                body: data,

            }),
            invalidatesTags: [],
        }),
        updateSession: builder.mutation({
            query: ({ data, id }) => ({
                url: `${sessionApi.endPoint}/update/${id}`,
                method: "PATCH",
                body: data,

            }),
            invalidatesTags: [],
        }),
    }),
});

export const {
    useCreateSessionMutation,
    useGetSessionListQuery,
    useUpdateSessionMutation,
} = SessionApi;
